module.exports = __webpack_public_path__ + "img/Piece_jj.4daf4d6f.png";